import { StaticActionItemCodes } from '@gp/constants/const';

export const RATING_OPT = [
  { text: 'High', value: '1' },
  { text: 'Medium', value: '2' },
  { text: 'Low', value: '3' },
];

export const DEFAULT_RISKS_ITEM = {
  id: '',
  category: '',
  rating: 0,
  comment: '',
};

export const DEFAULT_WORKPLANS_ITEM = {
  id: '',
  comment: '',
  due_date: '', // YYYY-MM-DD
  status: StaticActionItemCodes.NotStarted,
  user_name: '',
  user_id: '',
};
